module.exports = __webpack_public_path__ + "static/media/guide_mobile_05.f796ab43.svg";